import React from 'react';
import { STORE_DETAILS, ASSETS, GEO_COORDINATES } from '@/config/store';
import { SITE_URL, SEO, absoluteUrl } from '@/config/site';

/**
 * JSON-LD structured data for GroceryStore / LocalBusiness.
 * Rendered in DOM so crawlers that execute JS (e.g. Google) can index it.
 */
export function StructuredData() {
  const phone = STORE_DETAILS.phone.replace(/\s/g, '');

  const groceryStore = {
    '@context': 'https://schema.org',
    '@type': 'GroceryStore',
    '@id': `${SITE_URL}/#store`,
    name: STORE_DETAILS.name,
    alternateName: 'Bagbazar Provision Store',
    description: SEO.description,
    url: SITE_URL,
    telephone: phone,
    email: undefined,
    image: [
      absoluteUrl(ASSETS.storeInterior1),
      absoluteUrl(ASSETS.storeInterior2),
      absoluteUrl(ASSETS.storeInterior3),
      absoluteUrl(ASSETS.ownerPhoto),
      absoluteUrl(ASSETS.logoBlue),
    ],
    logo: absoluteUrl(ASSETS.logoBlue),
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Pokhara-1, Bagbazar',
      addressLocality: 'Pokhara',
      addressRegion: 'Kaski',
      addressCountry: 'NP',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: GEO_COORDINATES.latitude,
      longitude: GEO_COORDINATES.longitude,
    },
    hasMap: `https://www.google.com/maps/search/?api=1&query=${GEO_COORDINATES.latitude},${GEO_COORDINATES.longitude}`,
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday',
        ],
        opens: '06:00',
        closes: '21:00',
      },
    ],
    openingHours: 'Mo-Su 06:00-21:00',
    priceRange: '₨',
    currenciesAccepted: 'NPR',
    paymentAccepted: 'Cash, Mobile Payment',
    areaServed: {
      '@type': 'City',
      name: 'Pokhara',
    },
    founder: {
      '@type': 'Person',
      name: STORE_DETAILS.owner,
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: phone,
      contactType: 'customer service',
      areaServed: 'NP',
      availableLanguage: ['en', 'ne'],
    },
  };

  const organization = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    name: STORE_DETAILS.name,
    url: SITE_URL,
    logo: absoluteUrl(ASSETS.logoBlue),
    telephone: phone,
    address: groceryStore.address,
  };

  const webPage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${SITE_URL}/#webpage`,
    url: SITE_URL,
    name: SEO.defaultTitle,
    description: SEO.description,
    inLanguage: 'en-NP',
    isPartOf: { '@id': `${SITE_URL}/#organization` },
    about: { '@id': `${SITE_URL}/#store` },
    primaryImageOfPage: absoluteUrl(ASSETS.storeInterior1),
  };

  const breadcrumbList = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: SITE_URL,
      },
    ],
  };

  const scripts = [groceryStore, organization, webPage, breadcrumbList].map((data) => (
    <script
      key={String(data['@type'])}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  ));

  return <>{scripts}</>;
}
